import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

@Component({
    selector: 'shared-h',
    templateUrl: './h.shared.component.html',
    styleUrls: ['./h.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HComponent implements OnInit {
    @Input() public loading: boolean = false;
    @Input() public type: OLO.Components.HEADER_TYPE = '1';
    @Input() public inverted: boolean = false;
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public paddingTop: OLO.Components.MARGIN_SIZE = null;
    @Input() public paddingBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public brandAccent: boolean = false;
    @Input() public counter: number = null;
    @Input() public postContent: string | number;
    @Input() public preContent: string | number;
    @Input() public ellipsis: boolean = false;
    @Input() public center: boolean = false;

    public headerSizeClass: OLO.Components.HEADER_CLASS;

    ngOnInit() {
        this.headerSizeClass = this.assignHeaderSizeClass();
    }

    private assignHeaderSizeClass(): OLO.Components.HEADER_CLASS {
        switch (this.type) {
            case '0': return '-h0';
            case '1': return '-h1';
            case '2': return '-h2';
            case '3': return '-h3';
            case '4': return '-h4';
            case '5': return '-h5';
            case '6': return '-h6';
        }
    }
}
